import React from 'react';

import { UserOutlined } from '@ant-design/icons';
import {
  CardAvatar,
  CardHeader,
  CardProgress,
  VerticalSpace,
} from '@brokerbay/design-components';

import { UserLocalOnboardingProfile } from '../../types';

import {
  OnboardingCompleteProfileForm,
  OnboardingCompleteProfileFormValues,
} from '../../components';
import ProfileExistsAlert from './ProfileExistsAlert';

export type CompleteProfileViewProps = {
  isLicensed: boolean;
  initialValues: OnboardingCompleteProfileFormValues;
  handleSubmit: (values: UserLocalOnboardingProfile) => void;
  onRequestStepBack?: () => void;
  onEmailError?: () => void;
  profileExists?: boolean;
};

export const CompleteProfileView = (props: CompleteProfileViewProps) => {
  const {
    isLicensed,
    initialValues,
    handleSubmit,
    onRequestStepBack,
    onEmailError,
    profileExists,
  } = props;

  return (
    <VerticalSpace>
      <CardHeader
        title="Complete Your Profile"
        icon={<CardAvatar icon={UserOutlined} />}
        onRequestStepBack={onRequestStepBack}
      />
      {profileExists ? (
        <ProfileExistsAlert />
      ) : (
        <>
          <OnboardingCompleteProfileForm
            initialValues={initialValues}
            isLicensed={isLicensed}
            onSubmit={handleSubmit}
            onEmailError={onEmailError}
          />
          <CardProgress percent={(2 / 5) * 100} />
        </>
      )}
    </VerticalSpace>
  );
};
